export default "__VITE_ASSET__aQAgt2eB__"